import { Flex, Table, Th, Tr } from 'styling/GlobalStyles'
import { Td } from 'components/Td/Td'
import { ArrowLeft } from 'assets/icons/ArrowLeft'
import { formatParams } from 'utils/helpers'
import { useState } from 'react'
import usePaginate from 'hooks/usePaginate'
import { Title } from 'components/Dashboard/Title'
import { DashboardModalArrow, DashboardModalContainer, DashboardModalContent, DashboardModalWrapper } from 'pages/Dashboard/Dashboard.styled'
import { InfoIcon } from 'assets/icons/InfoIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { NoItems } from 'components/NoItems-fallback/NoItems'
import { endOfWeek, startOfWeek } from 'date-fns'
import { IGetFuelAlertsResponse } from 'types/api/fuelManagementApi.interface'
import { fuelAlertPriorities, fuelAlertRiskLevels } from './fuelData'

export const FuelAlertsModal = ({ closeModal }) => {
    const [params, setParams] = useState({
        dateFrom: startOfWeek(new Date(), { weekStartsOn: 1 }),
        dateTo: endOfWeek(new Date(), { weekStartsOn: 1 }),
    })
    const [list, setList] = useState<IGetFuelAlertsResponse['alerts']>([])
    const [loading, setLoading] = useState(false)

    const parserFunction = (data: IGetFuelAlertsResponse) => {
        return data.alerts
    }

    usePaginate('fuel/management/dashboard/fuel/alert', formatParams(params), null, parserFunction, setList, null, null, true, true, null, setLoading)

    return (
        <DashboardModalWrapper>
            <DashboardModalContainer style={{ width: screen.availWidth < 500 ? '100%' : '60vw' }} >
                <Flex width='100%' gap='1rem' style={{ margin: '2rem 0' }} >
                    <DashboardModalArrow onClick={closeModal}>
                        <ArrowLeft />
                    </DashboardModalArrow>

                    <Title
                        center
                        mainIcon={<InfoIcon />}
                        height={'fit-content'}
                        title='Alerts'
                        color='#FF4F46'
                        rightSide={<Flex gap='1rem' >
                            <CalendarInput
                                maxDate={new Date(params.dateTo)}
                                labelText='Start date'
                                defaultValue={params.dateFrom}
                                onChange={v => setParams(p => ({ ...p, dateFrom: v }))}
                            />
                            <CalendarInput
                                minDate={new Date(params.dateFrom)}
                                labelText='End date'
                                defaultValue={params.dateTo}
                                onChange={v => setParams(p => ({ ...p, dateTo: v }))}
                            />
                        </Flex>}
                    />
                </Flex>

                <DashboardModalContent width='100%' >
                    {loading ? null : list?.length ? <Table width='100%' height='100%' modal={true}>
                        <Th next minWidth={0}>
                            <Td w='30%' noTooltip text='Summary' />
                            <Td w='12%' noTooltip text='Risk' />
                            <Td w='12%' noTooltip text='Priority' />
                            <Td w='14%' noTooltip text='Machine' />
                            <Td w='14%' noTooltip text='Site' />
                            <Td w='10%' noTooltip text='Confidence' />
                            <Td w='8%' noTooltip text='Z-Score' />
                        </Th>
                        {list?.map((n) => (
                            <Tr key={n.id} minWidth={0}>
                                <Td w='30%' cutText noTooltip toolTipText={n.summary} text={n.summary} />
                                <Td w='12%' text={fuelAlertRiskLevels[n.riskLevel] || '/'} />
                                <Td w='12%' text={fuelAlertPriorities[n.priority] || '/'} />
                                <Td w='14%' text={n.machine?.name || '/'} />
                                <Td w='14%' text={n.site?.name || '/'} />
                                <Td w='10%' text={`${Math.round(n.confidence * 100)}%`} />
                                <Td w='8%' text={n.dispenseRateZscore ?? '/'} />
                            </Tr>
                        ))}
                    </Table> : <NoItems title='Alerts' />}
                </DashboardModalContent>
            </DashboardModalContainer>
        </DashboardModalWrapper>
    )
}
